import { render, staticRenderFns } from "./SignUpView.vue?vue&type=template&id=146f34c0&scoped=true&lang=html&"
import script from "./SignUpView.vue?vue&type=script&lang=js&"
export * from "./SignUpView.vue?vue&type=script&lang=js&"
import style0 from "./SignUpView.vue?vue&type=style&index=0&id=146f34c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f34c0",
  null
  
)

export default component.exports